import React, { createContext, useContext, useState } from 'react';
import PropTypes from 'prop-types';


export const initialValues = { isModalOpen: false, open: () => { }, close: () => { }, toggle: () => {} };
export const FilterModalContext = createContext(initialValues);

export const FilterModalProvider = ({ children }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const open = () => {
    setIsModalOpen(true);
  };

  const close = () => {
    setIsModalOpen(false);
  };
  const toggle = () => {
    setIsModalOpen(!isModalOpen);
  };
  return (
    <FilterModalContext.Provider value={{ isModalOpen, open, close, toggle }}>
      {children}
    </FilterModalContext.Provider>
  );
};
FilterModalProvider.propTypes = {
  children: PropTypes.any
};
export const useFilterModal = () => useContext(FilterModalContext);

export const withFilterModal = WrappedComponent => {
  return function FilterModalComponent(props) {
    return (
      <FilterModalContext.Consumer>
        {context => <WrappedComponent {...props} filterModalContext={context} />}
      </FilterModalContext.Consumer>
    );
  };
};